export default "__VITE_ASSET__03iYT6JT__"